export default __webpack_public_path__ + "img/24bed7739e6133cdeffd56bd4a017c78.png";